module.exports = __webpack_public_path__ + "img/clock-slim.7997a3a8.svg";